<div class="form_group search_bar">
  <mat-form-field class="srch" appearance="fill">
    <input
      #search
      matInput
      [placeholder]="placeholderText"
      (focus)="focusFunction()"
      (focusout)="focusOutFunction()"
      class="form_control" />
  </mat-form-field>
  <button mat-button matPrefix mat-icon-button>
    <figure>
      <img [src]="assetsConst.searchIcon" alt="" />
    </figure>
    <mat-icon *ngIf="showCrossIcon" (click)="clearInputField()">close</mat-icon>
  </button>
</div>